import { Component } from '@angular/core';
import { AttivitaCompletare } from '../../models/attivita-completare';
import { PrendiAttivitaCompletareResponse } from '../../models/prendi-attivita-completare-response';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
    selector: 'main [attivita-completare-view]',
  templateUrl: 'attivita-completare-view.component.html',
  host: { '[attr.id]': '\'content\'' }
})

export class AttivitaCompletareViewComponent {
  numToViewAttivitaCompletare: number = 0;
  attivitaCompletareList: AttivitaCompletare[] = [];
  attivitaCompletareResponse: PrendiAttivitaCompletareResponse;

  constructor(protected operationService: OperationsService,
              private viewManager: ViewManagerService) {}

  ngOnInit() {
    this.viewManager.svuotaMenu();
    this.loadProssimeAttivitaCompletare();
  }

  loadProssimeAttivitaCompletare() {
    this.operationService.prendiAttivitaCompletarePaginate({fromResult: this.attivitaCompletareList.length}).
      subscribe(response => this.attivitaCompletarePrese(response));
  }

  attivitaCompletarePrese(response: PrendiAttivitaCompletareResponse) {
    this.attivitaCompletareResponse = response;
    this.attivitaCompletareList = this.attivitaCompletareList.concat(response.attivita);
  }
}
